import { gql } from '__generated__';

export default gql(`
 query GetMollieConnections($id: ID!) {
    project(id: $id) {
      id
      payment_profiles {
        id
        default
      }
      mollie_connections {
        ...MollieConnectionFields
      }
      mollie_app {
        id
      }
    }
  }
`);
